import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
import { OBJECT_COORDINATES, PHONE_NUMBER } from '../filterQueryFormat/UnifiedEventPropertyTypes';
import { isExternalOptionsEnum } from './isExternalOptionsEnum';
import { isExternalOptionsField } from './isExternalOptionsField';
import { BooleanDataTypeIcon, DateDataTypeIcon, EnumerationDataTypeIcon, NumericDataTypeIcon, TextDataTypeIcon } from 'foundations-assets';
const propertyTypeToIconName = {
  [PropertyTypes.BOOLEAN]: 'booleanDataType',
  [PropertyTypes.DATE]: 'dateDataType',
  [PropertyTypes.DATE_TIME]: 'dateDataType',
  [PropertyTypes.ENUMERATION]: 'enumerationDataType',
  [PropertyTypes.NUMBER]: 'numericDataType',
  [PropertyTypes.STRING]: 'textDataType',
  [OBJECT_COORDINATES]: 'enumerationDataType',
  [PHONE_NUMBER]: 'numericDataType'
};
const iconNameToIconComponent = {
  booleanDataType: BooleanDataTypeIcon,
  dateDataType: DateDataTypeIcon,
  enumerationDataType: EnumerationDataTypeIcon,
  numericDataType: NumericDataTypeIcon,
  textDataType: TextDataTypeIcon
};
export const getIconComponentByName = iconName => iconNameToIconComponent[iconName];
export const isIconName = maybeIconName => maybeIconName in iconNameToIconComponent;
export const getIconComponentForPropertyType = propertyType => {
  return iconNameToIconComponent[propertyTypeToIconName[propertyType]];
};
export const hasPropertyTypeIcon = key => {
  return key in propertyTypeToIconName;
};
export const getOverriddenPropertyType = (field, getIsUngated, filterFamily) => {
  if (isExternalOptionsEnum(field, getIsUngated) && isExternalOptionsField(field, filterFamily, getIsUngated)) {
    return PropertyTypes.ENUMERATION;
  }
  return field.type;
};
export const getIconComponent = (field, getIsUngated, filterFamily) => {
  const type = getOverriddenPropertyType(field, getIsUngated, filterFamily);
  if (hasPropertyTypeIcon(type)) {
    const iconName = propertyTypeToIconName[type];
    return {
      icon: iconName,
      IconComponent: iconNameToIconComponent[iconName]
    };
  } else {
    return undefined;
  }
};